import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { LexiconDetail, lexiconDetailHead } from "@/components/LexiconDetail";
import { LexiconPage } from "@/components/LexiconPage";
import { resolvePilotId, pilotSlug, isPilot } from "@/lib/lexicon-pilot";

export const Route = createFileRoute("/glossary/$slug")({
  beforeLoad: ({ params }) => {
    const id = resolvePilotId(params.slug);
    if (!id) throw redirect({ to: "/concepts", replace: true });
    const en = pilotSlug(id, "en");
    // TR slug girilirse EN slug'una yönlendir (canonical EN)
    if (en !== params.slug) {
      throw redirect({ to: "/glossary/$slug", params: { slug: en }, replace: true });
    }
  },
  loader: ({ params }) => {
    const id = resolvePilotId(params.slug);
    if (!id || !isPilot(id)) throw notFound();
    return { id };
  },
  head: ({ loaderData }) =>
    loaderData
      ? lexiconDetailHead({
          id: loaderData.id,
          lang: "en",
          trSlug: loaderData.id,
          enSlug: pilotSlug(loaderData.id, "en"),
        })
      : { meta: [{ title: "Lexicon" }] },
  errorComponent: () => <LexiconPage lang="en" />,
  notFoundComponent: () => <LexiconPage lang="en" />,
  component: () => {
    const { id } = Route.useLoaderData();
    return <LexiconDetail id={id} lang="en" />;
  },
});
